import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "reactstrap";
import { usePermissions } from "../../contexts/PermissionContext";

const PermissionLoader = ({ children }) => {
  const { loading } = usePermissions();

  if (loading) {
    return (
      <div className="loader-overlay">
        <Spinner color="primary" style={{ width: "3rem", height: "3rem" }} />
      </div>
    );
  }

  return children;
};

PermissionLoader.propTypes = {
  children: PropTypes.node,
};

export default PermissionLoader;
